import { isString } from "lodash-es";
import React from "react";
import sanitize from "sanitize-html";

interface Props {
  html?: string;
}

const sanitizeConfig = {
  allowedTags: [
    "a",
    "b",
    "br",
    "em",
    "h1",
    "h2",
    "h3",
    "h4",
    "i",
    "img",
    "li",
    "ol",
    "p",
    "s",
    "strong",
    "table",
    "tbody",
    "td",
    "th",
    "thead",
    "tr",
    "u",
    "ul",
  ],
  allowedAttributes: { "*": ["style"], a: ["href", "target"], img: ["src"] },
  allowedSchemes: ["data"],
};

const sanitizeEmpty = {
  allowedTags: [],
  allowedAttributes: {},
};

export const isHtmlEmpty = (html?: string) => {
  if (!isString(html)) {
    return true;
  }

  const text = sanitize(html, sanitizeEmpty);

  return !text.trim().length;
};

export const HtmlRenderer: React.FunctionComponent<Props> = React.memo(({ html }: Props) => {
  if (!isString(html)) {
    return null;
  }

  const markup = { __html: sanitize(html, sanitizeConfig) };

  return <div className="html-renderer" dangerouslySetInnerHTML={markup} />;
});
